// @flow
import alt from '../alt';

import SchemaActions from '../actions/SchemaActions';
import NotificationActions from '../actions/NotificationActions';
import SchemaSource from '../sources/SchemaSource';

import _ from 'underscore';
import t from '../trans';

export type SchemaStoreState = {
    schemas: {[key: string]: {...}},
    state: string,
    loadingSchema: {...}
};

/**
 * Konfiguratsiooni haldamise store
 *
 * Olekudiagramm: PROCESSING -> OK / FAIL
 *
 */
class SchemaStore {
    state: SchemaStoreState;

    constructor() {
        this.state = {
            schemas: {},
            state: "OK",
            loadingSchema: null
        };
        this.bindActions(SchemaActions);
        this.exportAsync(SchemaSource);
    }

    /**
     * Toote laadimise käivitamine
     */
    onFetchSchema(schema) {
        if (this.state.schemas[schema] != null) return;

        this.setState({state: "PROCESSING", loadingSchema: schema});
        let p = this.getInstance().fetchSchema(schema);
        // We need to catch the exception - this is already processed but if we do not catch this we receive warning in console
        p.catch(function () {});
    }

    /**
     * Toote laadimine ebaõnnestus
     */
    onFetchConfigFailed(error) {
        this.processError(error);
    }

    processError(error) {
        let message = t('Server error');
        if (error.response) {
            if (error.response.data && error.response.data.error && error.response.data.error.message) {
                message = error.response.data.error.message;
            } else {
                switch (error.response.status) {
                    default:
                        message = t("Server error");
                }
            }
            switch (error.response.status) {
                default:
                    this.setState({state: "FAIL", loadingSchema: error.schema});
            }
        } else {
            this.setState({state: "FAIL", loadingSchema: error.schema});
        }
        NotificationActions.error.defer(message);
    }

    onFetchSchemaDone(response) {
        try {
            if (!_.has(response.data, '$schema')) throw t("Server error");

            let newSchemas = _.clone(this.state.schemas);
            newSchemas[response.schema] = response.data;
            this.setState({
                schemas: newSchemas,
                state: "OK",
                loadingSchema: response.schema
            });
        } catch (e) {
            if (!_.isString(e)) {
                console.log(e.toString());
                NotificationActions.error.defer(t("Server error"));
            } else NotificationActions.error.defer(e);
            this.setState({state: "FAIL", loadingSchema: response.schema});
        }
    }
}

export default alt.createStore(SchemaStore, 'SchemaStore');
